import { useEffect, useState } from 'react';
import axios from 'axios';
import { JOURNEYS as DEFAULT_JOURNEYS } from './journeys';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Module-level cache so multiple components don't re-fetch.
let _cache = null;
let _inflight = null;
const _listeners = new Set();

async function fetchJourneys() {
  if (_inflight) return _inflight;
  _inflight = axios.get(`${API}/journeys`).then((r) => {
    _cache = r.data;
    _listeners.forEach((cb) => cb(_cache));
    return _cache;
  }).catch(() => DEFAULT_JOURNEYS).finally(() => { _inflight = null; });
  return _inflight;
}

export function invalidateJourneys() {
  _cache = null;
  fetchJourneys();
}

export function useJourneys() {
  const [journeys, setJourneys] = useState(_cache || DEFAULT_JOURNEYS);
  useEffect(() => {
    let active = true;
    const cb = (d) => { if (active) setJourneys(d); };
    _listeners.add(cb);
    if (!_cache) fetchJourneys();
    else setJourneys(_cache);
    return () => { active = false; _listeners.delete(cb); };
  }, []);
  return journeys;
}
